import { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Map from '../components/Map';
import ListadoPedidos from '../components/ListadoPedidos';
import ListadoProductosPedidos from '../components/ListadoProductosPedidos';

const Pedidos = () => {
	const [tab, setTab] = useState(0)
	return (
		<Layout
			pagina={"Pedidos"}
		>
			<div className="w-full max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 animate-fadeIn">
				{/* Header Section */}
				<div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
					<div className="flex flex-col gap-1 text-left">
						<h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">Gestión de Pedidos</h1>
						<p className="text-slate-500 text-sm">Visualiza, crea y administra los pedidos de los clientes</p>
					</div>
					<Link
						className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white font-bold px-5 py-3 rounded-xl shadow-md transition-all active:scale-[0.98] text-sm w-full md:w-auto"
						to={"/nuevopedido"}
					>
						<FaPlus className='text-base' />
						<span>Nuevo Pedido</span>
					</Link>
				</div>

				{/* Segmented Control / Modern Tab Navigation */}
				<div className="flex flex-col sm:flex-row gap-2 bg-slate-100/80 p-1.5 rounded-2xl w-full max-w-3xl mb-6 shadow-inner">
					<button
						className={`flex-1 transition-all py-3 px-4 rounded-xl font-bold text-xs uppercase tracking-wider text-center ${
							tab === 0 
								? 'bg-white text-blue-900 shadow-sm ring-1 ring-black/5' 
								: 'text-slate-500 hover:text-slate-800 hover:bg-white/40'
						}`}
						onClick={() => setTab(0)}
					>
						🗺️ Pedidos en Mapa
					</button>
					<button
						className={`flex-1 transition-all py-3 px-4 rounded-xl font-bold text-xs uppercase tracking-wider text-center ${
							tab === 1 
								? 'bg-white text-blue-900 shadow-sm ring-1 ring-black/5' 
								: 'text-slate-500 hover:text-slate-800 hover:bg-white/40'
						}`}
						onClick={() => setTab(1)}
					>
						📋 Pedidos en Listado
					</button>
					<button
						className={`flex-1 transition-all py-3 px-4 rounded-xl font-bold text-xs uppercase tracking-wider text-center ${
							tab === 2 
								? 'bg-white text-blue-900 shadow-sm ring-1 ring-black/5' 
								: 'text-slate-500 hover:text-slate-800 hover:bg-white/40'
						}`}
						onClick={() => setTab(2)}
					>
						📦 Productos para Reparto
					</button>
				</div>

				{/* Content Section */}
				<div className="w-full">
					{tab === 0 ? (
						<div className="rounded-2xl overflow-hidden border border-slate-200/60 shadow-sm bg-white p-2 sm:p-4">
							<Map />
						</div>
					) : tab === 1 ? (
						<ListadoPedidos />
					) : (
						<div className="rounded-2xl border border-slate-200/60 shadow-sm bg-white p-4 sm:p-6">
							<ListadoProductosPedidos />
						</div>
					)}
				</div>
			</div>
		</Layout>
	)
}

export default Pedidos